import { call } from "redux-saga/effects";

import { callSagas, createSaga } from "../../../utils/saga";
import { refetchRepository } from "../client";
import slice from "../slice";
import { getRepositoriesSaga } from "./getRepositories";

type RefetchRepositoryPayload = {
  repositoryId: string;
};

function* refetchRepositoryInternal({
  repositoryId,
}: RefetchRepositoryPayload) {
  yield call(refetchRepository, repositoryId);
  yield callSagas([getRepositoriesSaga.apply({})]);
  return {
    repositoryId,
  };
}

const refetchRepositorySaga = createSaga(
  refetchRepositoryInternal,
  "refetchRepositorySaga",
  {
    sliceName: "repositories",
  },
);

slice.saga(refetchRepositorySaga, {
  start(state, { payload }) {
    state.loading[payload.repositoryId] = true;
    delete state.errors[payload.repositoryId];
  },
  success(state, { payload }) {
    delete state.loading[payload.repositoryId];
  },
  error(state, { payload, meta }) {
    delete state.loading[meta.args.repositoryId];
    state.errors[meta.args.repositoryId] = { error: payload };
  },
});
